export default "__VITE_ASSET__CTfAPGdJ__"